<div class="radio-group-container">
  <div class="radio-button-list">
      <app-radio-button
        [option]="option"
        *ngFor="let option of options"
        [selectedValue]="value?value:defaultValue"
        [name]="name"
        (changeCallback)="onInputChange($event)">
      </app-radio-button>
  </div>
  <div class="error-msg" *ngIf="showError() && formControl.errors.required">{{errorMessages.required}}</div>
</div>
